// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2RNah","inner":"Footer_inner__G8E7m"};